/* eslint-disable react/no-danger */ // we trust modalText
import React from 'react';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import CrossComponent from './CrossComponent';
import CloseOutsideBorderComponent from '../hocs/CloseOutsideBorderComponent';
import ModalData from '../../stores/ModalStore';

@observer
class ModalComponent extends React.Component {
  render() {
    const { showModal, modalHeader, modalText, closeModal } = this.props.ModalData;

    let modalComponent = null;

    if (showModal) {
      modalComponent = (
        <div>
          <div className="modal-backdrop" />
          <div className="modal">
            <h2>{modalHeader}</h2>
            <div dangerouslySetInnerHTML={{ __html: modalText }} />
            <CrossComponent onClickHandler={closeModal} />
          </div>
        </div>
      );
    }

    return modalComponent;
  }
}

ModalComponent.propTypes = {
  ModalData: PropTypes.shape({
    showModal: PropTypes.bool,
    modalHeader: PropTypes.string,
    modalText: PropTypes.string,
    closeModal: PropTypes.func,
  }),
};

ModalComponent.defaultProps = {
  ModalData: {
    showModal: false,
    modalHeader: '',
    modalText: '',
    closeModal: () => {},
  },
};

export default CloseOutsideBorderComponent(inject('ModalData')(ModalComponent), ModalData.closeModal, '.modal');
